/**
 * Gallery Slider block — slick carousel of single-gallery photos.
 *
 * One slide visible at a time, fade-style transition, prev/next arrows
 * positioned over the image at vertical center. Below the slider is a
 * black counter bar showing "Slide N of X — [alt text]"; that line is
 * kept in sync via slick's `afterChange` event using the JSON alt list
 * the PHP render writes to a data attribute.
 *
 * Clicking the active slide opens the shared singleton lightbox
 * (`window.ckLightbox`, see `_lightbox.js`) with the full-size image
 * URLs (`data-full` on each <img>, falling back to the rendered src).
 */

jQuery(function ($) {
    const prevArrow = '<button type="button" class="slick-prev" aria-label="Previous slide">' +
        '<svg viewBox="0 0 24 49" fill="none" aria-hidden="true"><path d="M20 4 L4 24.5 L20 45" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '</button>';

    const nextArrow = '<button type="button" class="slick-next" aria-label="Next slide">' +
        '<svg viewBox="0 0 24 49" fill="none" aria-hidden="true"><path d="M4 4 L20 24.5 L4 45" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '</button>';

    $('[data-ck-gallery-slider]').each(function () {
        const $slider = $(this);

        if ( $slider.hasClass('slick-initialized') ) {
            return;
        }

        let alts = [];
        try {
            alts = JSON.parse($slider.attr('data-slide-alts') || '[]');
        } catch (e) {
            alts = [];
        }

        const sliderId = $slider.attr('id');
        const $counter = sliderId
            ? $('[data-ck-gallery-counter-for="' + sliderId + '"]')
            : $();

        const total = $slider.children().length;

        const updateCounter = function (currentIndex) {
            if ( ! $counter.length ) return;
            const label = alts[currentIndex] || '';
            $counter.find('.ck-gallery-slider__counter-num').text('Slide ' + (currentIndex + 1) + ' of ' + total);

            const $sep = $counter.find('.ck-gallery-slider__counter-sep');
            const $alt = $counter.find('.ck-gallery-slider__counter-alt');

            if ( label ) {
                if ( ! $sep.length ) {
                    $counter.append('<span class="ck-gallery-slider__counter-sep">&nbsp;&mdash;&nbsp;</span>');
                }
                if ( ! $alt.length ) {
                    $counter.append('<span class="ck-gallery-slider__counter-alt"></span>');
                }
                $counter.find('.ck-gallery-slider__counter-alt').text(label);
                $counter.find('.ck-gallery-slider__counter-sep').show();
                $counter.find('.ck-gallery-slider__counter-alt').show();
            } else {
                $sep.hide();
                $alt.hide();
            }
        };

        $slider.on('afterChange', function (_event, _slick, currentSlide) {
            updateCounter(currentSlide);
        });

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            speed: 350,
            adaptiveHeight: false,
            prevArrow,
            nextArrow,
        });

        // Lightbox trigger: click the currently active slide image. The
        // URL list is built from non-cloned slides so the modal index
        // matches slick's logical slide index.
        $slider.on( 'click', '.slick-current img', function () {
            const urls = $slider.find( '.slick-slide:not(.slick-cloned) img' )
                .map( function () { return $(this).attr('data-full') || $(this).attr('src'); } )
                .get();
            const startIndex = $slider.slick( 'slickCurrentSlide' );
            if ( window.ckLightbox ) {
                window.ckLightbox.open( urls, startIndex );
            }
        } );
    });
});
